import {web} from '#/alf'

export const chatTokens = {
  radius: {
    xl: 22,
    lg: 16,
    md: 12,
    pill: 999,
  },
  space: {
    2: 8,
    3: 12,
    4: 16,
    5: 20,
  },
  type: {
    base: 15,
    small: 12,
    title: 17,
    weightBold: '600' as const,
    weightRegular: '400' as const,
  },
  colors: {
    bg: '#F6F7F9',
    surface: 'rgba(255,255,255,0.72)',
    border: 'rgba(0,0,0,0.08)',
    text: '#111',
    textSubtle: 'rgba(0,0,0,0.55)',
    bubbleMe: '#6D5CFF',
    bubbleMeText: '#fff',
    bubbleThem: '#FFFFFF',
    bubbleThemText: '#111',
    icon: 'rgba(0,0,0,0.72)',
    iconSubtle: 'rgba(0,0,0,0.5)',
    chip: 'rgba(0,0,0,0.06)',
  },
  glass: {
    background: 'rgba(255,255,255,0.70)',
    borderLight: 'rgba(255,255,255,0.35)',
    borderDark: 'rgba(0,0,0,0.06)',
    blur: 'blur(14px) saturate(130%)',
    shadow: '0 8px 24px rgba(0,0,0,0.08)',
  },
}

export const glassSurface = {
  backgroundColor: chatTokens.glass.background,
  borderWidth: 1,
  borderColor: chatTokens.glass.borderDark,
  ...web({
    backdropFilter: chatTokens.glass.blur,
    WebkitBackdropFilter: chatTokens.glass.blur,
    boxShadow: chatTokens.glass.shadow,
  }),
}
